export default {
  rows: [
    {
      codes: ['A20', 'A27'],
      categoryDescription: 'Hoist',
      categoryCode: 'A20',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A25', 'A26'],
      categoryDescription: 'M.E.W.P. Scissor',
      categoryCode: 'A25',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A26'],
      categoryDescription: 'M.E.W.P. Boom',
      categoryCode: 'A26',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A27'],
      categoryDescription: 'M.E.W.P. Mast Climber',
      categoryCode: 'A27',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A31'],
      categoryDescription: 'Ride On Roller',
      categoryCode: 'A31',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A32'],
      categoryDescription: 'Soil - Landfill Compactor',
      categoryCode: 'A32',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A66', 'A02', 'A40'],
      categoryDescription: 'Crawler Crane above 10 tonne',
      categoryCode: 'A02',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A04'],
      categoryDescription: 'Tower Crane',
      categoryCode: 'A04',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A35'],
      categoryDescription: 'Crawler - Tractor / Side Boom',
      categoryCode: 'A35',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A66', 'A60', 'A02', 'A40'],
      categoryDescription: 'Lorry Loader',
      categoryCode: 'A36',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A66', 'A36', 'A40'],
      categoryDescription: 'Slinger Signaller',
      categoryCode: 'A40',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A66', 'A60', 'A02', 'A40'],
      categoryDescription: 'Mobile Crane',
      categoryCode: 'A60',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A61', 'A62', 'A40'],
      categoryDescription: 'Appointed Person',
      categoryCode: 'A61',
      cpdCourse: 'Lifting Supervision and Management',
    },
    {
      codes: ['A62', 'A40'],
      categoryDescription: 'Crane / Lifting Operations Supervisor',
      categoryCode: 'A62',
      cpdCourse: 'Lifting Supervision and Management',
    },
    {
      codes: ['A64'],
      categoryDescription: 'Overhead Travelling Crane',
      categoryCode: 'A64',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A66', 'A40'],
      categoryDescription: 'Compact Crane',
      categoryCode: 'A66',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A66', 'A60', 'A02', 'A40'],
      categoryDescription: 'Grader',
      categoryCode: 'A19',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A19'],
      categoryDescription: 'Crawler - Tractor / Dozer',
      categoryCode: 'A34',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A05'],
      categoryDescription: 'Dragline',
      categoryCode: 'A05',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A10'],
      categoryDescription: 'Excavator 180 below 5 tonnes',
      categoryCode: 'A10',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A12'],
      categoryDescription: 'Excavator 180 above 5 tonnes',
      categoryCode: 'A12',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A21', 'A23', 'A02'],
      categoryDescription: 'Wheeled Loading Shovel',
      categoryCode: 'A21',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A22'],
      categoryDescription: 'Tracked Loading Shovel',
      categoryCode: 'A22',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A23'],
      categoryDescription: 'Skid Steer Loader',
      categoryCode: 'A23',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A24'],
      categoryDescription: 'Motorised Scraper',
      categoryCode: 'A24',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A37'],
      categoryDescription: 'Trencher',
      categoryCode: 'A37',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A14'],
      categoryDescription: 'R.T.F.L./ Masted Truck',
      categoryCode: 'A14',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A15'],
      categoryDescription: 'Forklift Side - Loader',
      categoryCode: 'A15',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A14'],
      categoryDescription: 'Industrial Forklift Truck',
      categoryCode: 'A16',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A18'],
      categoryDescription: 'Reach Truck',
      categoryCode: 'A18',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A17', 'A14'],
      categoryDescription: 'Telescopic Handler',
      categoryCode: 'A17',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A06', 'A44'],
      categoryDescription: 'Truck Mounted Boom Concrete Pump',
      categoryCode: 'A06',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A30'],
      categoryDescription: 'Piling Rig Tripod',
      categoryCode: 'A30',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A41', 'A23'],
      categoryDescription: 'Loader - Compressor',
      categoryCode: 'A41',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A42', 'A43'],
      categoryDescription: 'Crusher',
      categoryCode: 'A42',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A43'],
      categoryDescription: 'Screener',
      categoryCode: 'A43',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A44'],
      categoryDescription: 'Trailer Mounted Concrete Pump',
      categoryCode: 'A44',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A45'],
      categoryDescription: 'Piling Rig - Driven below 20 tonnes',
      categoryCode: 'A45',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A46'],
      categoryDescription: 'Piling Rig - Driven above 20 tonnes',
      categoryCode: 'A46',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A47'],
      categoryDescription: 'Piling Rig - Bored below 20 tonnes',
      categoryCode: 'A47',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A48'],
      categoryDescription: 'Piling Rig - Bored above 20 tonnes',
      categoryCode: 'A48',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['D90'],
      categoryDescription: 'Demolition Plant',
      categoryCode: 'D90',
      cpdCourse: 'Demolition',
    },
    {
      codes: ['D91'],
      categoryDescription: 'Demolition Plant - Pedestrian Operated',
      categoryCode: 'D91',
      cpdCourse: 'Demolition',
    },
    {
      codes: ['D92'],
      categoryDescription: 'Demolition Plant – Skid Steer Tool Carrier',
      categoryCode: 'D92',
      cpdCourse: 'Demolition',
    },
    {
      codes: ['A09'],
      categoryDescription: 'Forward Tipping Dumper',
      categoryCode: 'A09',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A33'],
      categoryDescription: 'Agricultural Tractor',
      categoryCode: 'A33',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A39'],
      categoryDescription: 'Skip Handler',
      categoryCode: 'A39',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A49'],
      categoryDescription: 'Loader / Securer - non STGO',
      categoryCode: 'A49',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A50', 'A49'],
      categoryDescription: 'Loader / Securer - STGO',
      categoryCode: 'A50',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A51'],
      categoryDescription: 'Multi Service Vehicle',
      categoryCode: 'A51',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A56', 'A09'],
      categoryDescription: 'Dump Truck Articulated Chassis',
      categoryCode: 'A56',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A57'],
      categoryDescription: 'Dump Truck Rigid Chassis',
      categoryCode: 'A57',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A58'],
      categoryDescription: 'Excavator 360 below 10 Tonne',
      categoryCode: 'A58',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A59', 'A12'],
      categoryDescription: 'Excavator 360 above 10 Tonne',
      categoryCode: 'A59',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A67'],
      categoryDescription: 'Tunnel Locomotive',
      categoryCode: 'A67',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A68'],
      categoryDescription: 'Plant Driving',
      categoryCode: 'A68',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A71'],
      categoryDescription: 'Soil Stabiliser',
      categoryCode: 'A71',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A72'],
      categoryDescription: 'Static Concrete Placing Boom',
      categoryCode: 'A72',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A73'],
      categoryDescription: 'Plant and Vehicle Marshaller',
      categoryCode: 'A73',
      cpdCourse: 'Earth Moving and Compaction',
    },
    {
      codes: ['A74'],
      categoryDescription: 'Piling Rig Attendant',
      categoryCode: 'A74',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A75'],
      categoryDescription: 'Conveying Pump',
      categoryCode: 'A75',
      cpdCourse: 'Piling and pumping of materials',
    },
    {
      codes: ['A77'],
      categoryDescription: 'Telescopic Handler 360 slew',
      categoryCode: 'A77',
      cpdCourse: 'Lifting and Lifting Equipment',
    },
    {
      codes: ['A78'],
      categoryDescription: 'Vacuum Excavator',
      categoryCode: 'A78',
      cpdCourse: 'Earth Moving and Compaction',
    },
  ],
}
